import { 
  SunIcon, 
  MoonIcon, 
  ComputerDesktopIcon 
} from '@heroicons/react/24/outline';
import { useTheme } from '../providers/ThemeProvider';

interface ThemeSwitcherProps {
  compact?: boolean;
}

export default function ThemeSwitcher({ compact = false }: ThemeSwitcherProps) {
  const { theme, setTheme } = useTheme();

  if (compact) {
    return (
      <div className="flex flex-col space-y-2">
        <button
          onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-sidebar-text hover:text-sidebar-text-active hover:bg-sidebar-item-hover transition-all duration-200"
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === 'light' ? (
            <MoonIcon className="h-4 w-4" />
          ) : (
            <SunIcon className="h-4 w-4" />
          )}
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center bg-muted rounded-lg p-1">
      <button
        onClick={() => setTheme('light')}
        className={`
          inline-flex items-center justify-center p-1.5 text-xs font-medium rounded-md transition-all duration-200
          ${theme === 'light'
            ? 'bg-background text-foreground shadow-soft-sm'
            : 'text-muted-foreground hover:text-foreground'
          }
        `}
        title="Light mode"
      >
        <SunIcon className="h-4 w-4" />
      </button>
      <button
        onClick={() => setTheme('dark')}
        className={`
          inline-flex items-center justify-center p-1.5 text-xs font-medium rounded-md transition-all duration-200
          ${theme === 'dark'
            ? 'bg-background text-foreground shadow-soft-sm'
            : 'text-muted-foreground hover:text-foreground'
          }
        `}
        title="Dark mode"
      >
        <MoonIcon className="h-4 w-4" />
      </button>
      <button
        onClick={() => setTheme('system')}
        className={`
          inline-flex items-center justify-center p-1.5 text-xs font-medium rounded-md transition-all duration-200
          ${theme === 'system'
            ? 'bg-background text-foreground shadow-soft-sm'
            : 'text-muted-foreground hover:text-foreground'
          }
        `}
        title="System preference"
      >
        <ComputerDesktopIcon className="h-4 w-4" />
      </button>
    </div>
  );
}
